import { Code2, Smartphone, Globe, Mail, Linkedin, Github, CheckCircle2, Star, Zap, Cpu, Database } from 'lucide-react'

export const siteConfig = {
  name: 'Lymoun',
  description: 'Full-stack development solutions for modern businesses',
  url: 'https://lymoun.dev',
  email: 'support@lymoun.agency',
}

export const navigation = [
  { name: 'Home', href: '#home' },
  { name: 'Services', href: '#services' },
  { name: 'Process', href: '#process' },
  { name: 'About', href: '#about' },
  { name: 'Contact', href: '#contact' },
]

export const heroData = {
  badge: 'Premium Development Services',
  title: 'We don\'t build apps. We build obsessions.',
  description: 'Expert development team delivering custom software solutions with precision, reliability, and cutting-edge technology. Transform your ideas into production-ready applications.',
}

export const stats = [
  { value: '50+', label: 'Projects Delivered' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '24/7', label: 'Support Available' },
  { value: '2', label: 'Expert Developers' },
]

export const services = [
  {
    icon: Code2,
    title: 'Custom Software Development',
    description: 'Enterprise-grade applications built with modern architecture and best practices to scale with your business needs.',
  },
  {
    icon: Globe,
    title: 'Web Application Development',
    description: 'High-performance web solutions using cutting-edge technologies for optimal user experience and conversion rates.',
  },
  {
    icon: Smartphone,
    title: 'Mobile Solutions',
    description: 'Cross-platform mobile applications that deliver seamless experiences across all devices and platforms.',
  },
  {
    icon: Database,
    title: 'Backend Systems',
    description: 'Robust server architecture, API development, and database design for reliable and scalable applications.',
  },
  {
    icon: Cpu,
    title: 'DevOps & Deployment',
    description: 'Complete CI/CD pipeline setup, cloud infrastructure, and deployment strategies for optimal performance.',
  },
  {
    icon: Zap,
    title: 'Performance Optimization',
    description: 'Application optimization, speed enhancements, and technical improvements for better user engagement.',
  },
]

export const process = [
  {
    step: '01',
    title: 'Discovery & Strategy',
    description: 'Deep dive into your business goals, technical requirements, and project vision to create a solid foundation.'
  },
  {
    step: '02',
    title: 'Design & Architecture',
    description: 'Strategic planning, system architecture design, and technology stack selection for optimal performance.'
  },
  {
    step: '03',
    title: 'Development & Testing',
    description: 'Agile development process with continuous testing, regular updates, and quality assurance checks.'
  },
  {
    step: '04',
    title: 'Launch & Support',
    description: 'Seamless deployment, thorough testing, and ongoing maintenance with 24/7 support availability.'
  },
]

export const technologies = [
  'React', 'Next.js', 'TypeScript', 'Node.js', 'Python',
  'PostgreSQL', 'MongoDB', 'AWS', 'Docker', 'Kubernetes',
  'GraphQL', 'Tailwind CSS', 'React Native'
]

export const features = [
  'Full-stack development expertise',
  'Agile and transparent workflow',
  'Clean, maintainable code architecture',
  'Continuous communication & updates',
  'Long-term support and maintenance',
  'Performance optimization focus',
  'Security best practices',
  'Scalable infrastructure design'
]

export const socialLinks = [
  { icon: Github, href: '#', label: 'GitHub' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
]